export const ieee = 'ieee'
export const mla8 = 'mla8'
export const mla = 'mla'
export const mla7 = 'mla7'
